<template>
  <a :href="subNav.url"
    :class="{ active: isOpen, 'has-dropdown': hasChildren }"
    @mouseenter="isOpen = true"
    @mouseleave="isOpen = false"
  >
    {{ subNav.title }} <img v-if="hasChildren" src="/images/icons/menu-down.svg" alt="">
    <div v-if="subNav.children && isOpen" class="sub-sub-menu">
      <a v-for="child in subNav.children" :key="child.id" :href="child.url">{{ child.title }}</a>
    </div>
  </a>
</template>

<script>
export default {
  props: {
    subNav: {
      type: Object,
      required: true,
    },
  },

  data () {
    return {
      isOpen: false,
    }
  },

  computed: {
    hasChildren () {
      const children = this.subNav.children
      return children && children.length > 0
    },
  },

  watch: {
    isOpen (newValue) {
      document.getElementById('site-header').style.overflow = newValue ? 'visible' : 'hidden'
    }
  },
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/HeaderSubMenu.vue